import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Direct access to Atlanta Passport Agency",
      "No long drive required — courier handles everything",
      "Perfect for music industry and medical travel deadlines",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Direct access to Atlanta Passport Agency",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed at the Atlanta Passport Agency",
      "Life-or-death emergencies only",
      "Must visit Atlanta Passport Agency at 805 Broadway",
      "Same-day if approved (rare)",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function NashvilleProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Nashville"
      introText="Nashville is the only Tennessee city with a regional passport agency — the Atlanta Passport Agency at 805 Broadway. This gives Music City travelers a unique advantage, but the agency still requires pre-scheduled appointments and only handles life-or-death emergencies for walk-ins. Here is how your passport processing options compare, and why most Nashville residents, Vanderbilt professionals, and music industry travelers choose a U.S. Department of State registered passport courier for predictable, professional processing."
      options={options}
      emergencyDescription="The Atlanta Passport Agency at 805 Broadway Suite 400 is the only regional passport agency in Tennessee. Located in the heart of downtown Nashville near Music Row, it handles emergency passport applications but only by pre-scheduled NPIC appointment — no walk-ins accepted. For life-or-death emergencies (immediate family death or critical illness abroad), same-day processing may be available. For any other urgency, appointments typically have a 2-3 week wait, and even with an appointment, you need to be prepared for a full-day commitment with no guarantee of same-day issuance."
      disclaimerText="*Processing speed depends on eligibility and documentation. Nashville is the only Tennessee city with a regional passport agency — located at 805 Broadway. Not all applicants qualify for Regional Agency Processing."
    />
  );
}